
<form class="mailing-list-signup" @submit="onSubmit">
  <div v-if="success" class="success-message">Thanks, you're now signed up.</div>
    
  <template v-else>
    <input type="email" name="email" id="email" required v-model="email_signup.email" placeholder="Enter email address">
    <div class="error" v-if="errors.email">{{ errors.email }}</div>
    <button type="submit" class="button button--large button button--filled--blue">Sign Up</button>
  </template>
</form>
